import * as types from '../actions/action-types';
import _ from 'lodash';

const sexes = [
  'Both Sexes',
  'Female',
  'Male'
];

const ages = [
  'All Ages',
  '0–14',
  '15–24',
  '25–34',
  '35–44',
  '45–54',
  '55–64',
  '65–74',
  '75+'
];

const races = [
  'All Races-All Origins',
  'Non-Hispanic White',
  'Non-Hispanic Black',
  'Hispanic'
];

const defaults = {
  loading: true,
  sexes,
  ages,
  races,
  sex: sexes[0],
  age: ages[0],
  race: races[0],
  dataBySex: {},
  dataByAge: {},
  dataByRace: []
};

function setSex(store, sex) {
  const {dataByAge, dataByRace} = generateData(store.rawData, sex, store.age, store.race);
  return {
    ...store,
    sex,
    dataByAge,
    dataByRace
  }
}

function setAge(store, age) {
  const {dataBySex, dataByRace} = generateData(store.rawData, store.sex, age, store.race);
  return {
    ...store,
    age,
    dataBySex,
    dataByRace
  }
}

function setRace(store, race) {
  const {dataBySex, dataByAge} = generateData(store.rawData, store.sex, store.age, race);
  return {
    ...store,
    race,
    dataBySex,
    dataByAge
  }
}

function reset(store){
  const {dataBySex, dataByAge, dataByRace} = generateData(store.rawData);
  return {
    ...store,
    sex: sexes[0],
    age: ages[0],
    race: races[0],
    dataBySex,
    dataByAge,
    dataByRace
  }
}

function generateData(rawData, sex = sexes[0], age = ages[0], race = races[0]) {
  const dataBySex = _.chain(rawData)
    .filter(d => {
      return d.age === age && d.race === race;
    })
    .groupBy('year')
    .mapValues(y => {
      return _.keyBy(y, 'sex');
    })
    .value();

  const dataByAge = _.chain(rawData)
    .filter(d => {
      return d.sex === sex && d.race === race && d.age !== ages[0];
    })
    .groupBy('year')
    .value();

  const dataByRace = _.chain(rawData)
    .filter(d => {
      return d.age === age && d.sex === sex;
    })
    .sortBy(r => {
      return _.indexOf(races, r.race)
    })
    .value();

  return {dataBySex, dataByAge, dataByRace};
}

function setData(store, rawData){
  const {dataBySex, dataByAge, dataByRace} = generateData(rawData);

  return {
    ...store,
    loading: false,
    rawData,
    dataBySex,
    dataByAge,
    dataByRace
  }
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.DEMOGRAPHICS_DATA_RECEIVED:
      return setData(store, action.data);
    case types.SELECT_SEX:
      return setSex(store, action.sex);
    case types.SELECT_AGE:
      return setAge(store, action.age);
    case types.SELECT_RACE:
      return setRace(store, action.race);
    case types.RESET_DEMO:
      return reset(store);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/demographics-reducer.js